// opencv-loader.ts
let opencvReady: Promise<void> | null = null;

export function loadOpenCV() {
  if (opencvReady) return opencvReady;

  opencvReady = new Promise<void>((resolve) => {
    if ((window as any).cv && (window as any).cv.imread) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = "https://docs.opencv.org/4.x/opencv.js";
    script.async = true;
    script.onload = () => {
      (window as any).cv.onRuntimeInitialized = () => resolve();
    };
    document.body.appendChild(script);
  });

  return opencvReady;
}
